import { useTranslation } from "react-i18next";import React from 'react';

// Professional SVG Vehicle Illustrations Library
// These match the style from fleet management reference designs

// Cargo Van - High Fidelity 2.5D
export const CargoVanSVG = ({ className = "", fillColor = "#fdfdfd", accentColor = "#cbd5e1" }) =>
<svg viewBox="0 0 300 120" className={className} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="vanBodyGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: fillColor, stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#e2e8f0", stopOpacity: 1 }} />
      </linearGradient>
      <filter id="vanShadow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
        <feOffset dx="2" dy="4" result="offsetblur" />
        <feComponentTransfer><feFuncA type="linear" slope="0.3" /></feComponentTransfer>
        <feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
    </defs>
    {/* Ground Shadow */}
    <ellipse cx="160" cy="110" rx="100" ry="8" fill="rgba(0,0,0,0.1)" />

    {/* Chassis/Body */}
    <rect x="70" y="35" width="190" height="65" rx="10" fill="url(#vanBodyGrad)" filter="url(#vanShadow)" />
    <path d="M70 100 L70 55 Q70 35 90 35 L130 35 L130 100 Z" fill="url(#vanBodyGrad)" />

    {/* Windows with Glass Effect */}
    <rect x="80" y="42" width="45" height="30" rx="6" fill="#1e293b" />
    <rect x="85" y="45" width="35" height="20" rx="3" fill="#38bdf8" opacity="0.4" />
    <rect x="88" y="48" width="15" height="4" rx="1" fill="white" opacity="0.3" />

    {/* Detail Lines */}
    <line x1="145" y1="40" x2="145" y2="90" stroke="#94a3b8" strokeWidth="1" strokeDasharray="4 2" />
    <circle cx="145" cy="65" r="2" fill="#94a3b8" />

    {/* Wheels - Detailed Rendering */}
    <g transform="translate(100, 100)">
      <circle cx="0" cy="0" r="18" fill="#0f172a" />
      <circle cx="0" cy="0" r="12" fill="#334155" />
      <circle cx="0" cy="0" r="4" fill="#64748b" />
    </g>
    <g transform="translate(230, 100)">
      <circle cx="0" cy="0" r="18" fill="#0f172a" />
      <circle cx="0" cy="0" r="12" fill="#334155" />
      <circle cx="0" cy="0" r="4" fill="#64748b" />
    </g>

    {/* Headlight & Taillight */}
    <rect x="255" y="60" width="6" height="20" rx="3" fill="#facc15" filter="blur(1px)" />
    <rect x="68" y="60" width="4" height="15" rx="2" fill="#ef4444" opacity="0.8" />
  </svg>;


// Box Truck - High Fidelity
export const BoxTruckSVG = ({ className = "", fillColor = "#fdfdfd", containerColor = "#f8fafc" }) =>
<svg viewBox="0 0 340 140" className={className} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="boxContainerGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: containerColor, stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#e2e8f0", stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <ellipse cx="180" cy="115" rx="120" ry="10" fill="rgba(0,0,0,0.1)" />

    {/* Container */}
    <rect x="110" y="20" width="210" height="85" rx="4" fill="url(#boxContainerGrad)" stroke="#cbd5e1" strokeWidth="1" />
    {/* Realistic Ribs */}
    <g opacity="0.4">
      <line x1="150" y1="20" x2="150" y2="105" stroke="white" strokeWidth="2" />
      <line x1="152" y1="20" x2="152" y2="105" stroke="#94a3b8" strokeWidth="1" />
      <line x1="190" y1="20" x2="190" y2="105" stroke="white" strokeWidth="2" />
      <line x1="192" y1="20" x2="192" y2="105" stroke="#94a3b8" strokeWidth="1" />
      <line x1="230" y1="20" x2="230" y2="105" stroke="white" strokeWidth="2" />
      <line x1="232" y1="20" x2="232" y2="105" stroke="#94a3b8" strokeWidth="1" />
    </g>

    {/* Cab with Depth */}
    <path d="M35 105 L35 55 Q35 35 55 35 L110 35 L110 105 Z" fill={fillColor} stroke="#cbd5e1" strokeWidth="1" />
    <rect x="45" y="42" width="55" height="32" rx="4" fill="#0f172a" />
    <rect x="50" y="45" width="45" height="20" rx="2" fill="#38bdf8" opacity="0.3" />

    {/* Wheels */}
    <g transform="translate(75, 105)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
      <circle cx="0" cy="0" r="5" fill="#64748b" />
    </g>
    <g transform="translate(260, 105)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
      <circle cx="0" cy="0" r="5" fill="#64748b" />
    </g>

    {/* Bumper & Details */}
    <rect x="30" y="102" width="90" height="8" rx="4" fill="#1e293b" />
    <rect x="315" y="60" width="5" height="25" rx="2" fill="#fbbf24" />
  </svg>;


// Semi Truck with Trailer - High Fidelity 2.5D
export const SemiTruckSVG = ({ className = "", cabColor = "#fdfdfd", trailerColor = "#ef4444", capacityPercent = null }) =>
<svg viewBox="0 0 420 160" className={className} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="cabGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: cabColor, stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#e2e8f0", stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient id="trailerGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: trailerColor, stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#991b1b", stopOpacity: 1 }} />
      </linearGradient>
      <filter id="truckShadow" x="-10%" y="-10%" width="120%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="4" />
        <feOffset dx="4" dy="6" result="offsetblur" />
        <feComponentTransfer><feFuncA type="linear" slope="0.4" /></feComponentTransfer>
        <feMerge><feMergeNode /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
    </defs>

    {/* Large Ground Shadow */}
    <ellipse cx="210" cy="140" rx="180" ry="12" fill="rgba(0,0,0,0.1)" />

    {/* Trailer with Depth */}
    <rect x="130" y="25" width="260" height="95" rx="6" fill="url(#trailerGrad)" filter="url(#truckShadow)" />
    {/* Trailer Highlights & Texture */}
    <g opacity="0.15">
      <rect x="140" y="35" width="240" height="2" fill="white" />
      <rect x="140" y="45" width="240" height="1" fill="white" />
    </g>

    {/* Capacity Overlay */}
    {capacityPercent !== null &&
  <g transform="translate(260, 75)">
        <rect x="-50" y="-25" width="100" height="50" rx="25" fill="rgba(255,255,255,0.15)" stroke="white" strokeWidth="1" />
        <text x="0" y="10" fontSize="32" fontWeight="bold" fill="white" textAnchor="middle" style={{ fontVariantNumeric: 'tabular-nums' }}>{capacityPercent}%</text>
      </g>
  }

    {/* Cab - 2.5D Construction */}
    <g filter="url(#truckShadow)">
      {/* Main Cab Block */}
      <rect x="30" y="45" width="110" height="75" rx="6" fill="url(#cabGrad)" stroke="#cbd5e1" strokeWidth="1" />
      {/* Front Nose */}
      <path d="M140 120 L155 120 L155 60 L140 60 Z" fill="#94a3b8" />
      {/* Glass */}
      <rect x="40" y="55" width="55" height="35" rx="4" fill="#0f172a" />
      <rect x="45" y="58" width="45" height="20" rx="3" fill="#38bdf8" opacity="0.3" />
      <rect x="100" y="55" width="30" height="35" rx="4" fill="#0f172a" />
      <rect x="105" y="58" width="20" height="20" rx="3" fill="#38bdf8" opacity="0.2" />
    </g>

    {/* Wheels - Multi-stack */}
    {[65, 290, 360].map((cx, i) =>
  <g key={i} transform={`translate(${cx}, 125)`}>
        <circle cx="0" cy="0" r="22" fill="#0f172a" />
        <circle cx="0" cy="0" r="16" fill="#334155" />
        <circle cx="0" cy="0" r="7" fill="#64748b" />
      </g>
  )}

    {/* Chrome Parts */}
    <rect x="20" y="60" width="12" height="25" rx="2" fill="#94a3b8" />
    <rect x="140" y="65" width="15" height="45" rx="2" fill="#e2e8f0" stroke="#cbd5e1" />
  </svg>;


// Pickup Truck - High Fidelity
export const PickupTruckSVG = ({ className = "", fillColor = "#fdfdfd" }) =>
<svg viewBox="0 0 280 120" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="140" cy="105" rx="100" ry="8" fill="rgba(0,0,0,0.1)" />

    {/* Bed */}
    <rect x="140" y="50" width="120" height="45" rx="6" fill={fillColor} stroke="#cbd5e1" strokeWidth="1" />
    <rect x="145" y="55" width="110" height="35" rx="2" fill="#f1f5f9" />

    {/* Cab */}
    <path d="M30 95 L30 55 Q30 35 50 35 L130 35 Q140 35 140 45 L140 95 Z" fill={fillColor} stroke="#cbd5e1" strokeWidth="1" />
    <rect x="40" y="42" width="40" height="30" rx="4" fill="#0f172a" />
    <rect x="45" y="45" width="30" height="20" rx="2" fill="#38bdf8" opacity="0.3" />
    <rect x="90" y="42" width="40" height="30" rx="4" fill="#0f172a" />
    <rect x="95" y="45" width="30" height="20" rx="2" fill="#38bdf8" opacity="0.2" />

    {/* Wheels */}
    <g transform="translate(65, 95)">
      <circle cx="0" cy="0" r="18" fill="#0f172a" />
      <circle cx="0" cy="0" r="12" fill="#334155" />
    </g>
    <g transform="translate(210, 95)">
      <circle cx="0" cy="0" r="18" fill="#0f172a" />
      <circle cx="0" cy="0" r="12" fill="#334155" />
    </g>
  </svg>;


// Flatbed Truck - High Fidelity
export const FlatbedTruckSVG = ({ className = "", fillColor = "#fdfdfd" }) =>
<svg viewBox="0 0 340 130" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="180" cy="115" rx="130" ry="10" fill="rgba(0,0,0,0.1)" />
    {/* Platform with depth */}
    <rect x="100" y="75" width="220" height="20" rx="2" fill="#334155" />
    <rect x="100" y="70" width="220" height="8" rx="1" fill="#64748b" />

    {/* Cabin */}
    <path d="M30 110 L30 55 Q30 35 55 35 L120 35 L120 110 Z" fill={fillColor} stroke="#cbd5e1" strokeWidth="1" />
    <rect x="45" y="45" width="60" height="35" rx="4" fill="#0f172a" />
    <rect x="50" y="48" width="50" height="20" rx="2" fill="#38bdf8" opacity="0.3" />

    {/* Wheels */}
    <g transform="translate(75, 110)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
      <circle cx="0" cy="0" r="5" fill="#64748b" />
    </g>
    <g transform="translate(280, 110)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
      <circle cx="0" cy="0" r="5" fill="#64748b" />
    </g>
  </svg>;


// Refrigerated Truck (Reefer) - High Fidelity
export const RefrigeratedTruckSVG = ({ className = "", fillColor = "#fdfdfd", containerColor = "#eff6ff" }) =>
<svg viewBox="0 0 360 140" className={className} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="reeferGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: containerColor, stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#dbeafe", stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <ellipse cx="180" cy="115" rx="130" ry="10" fill="rgba(0,0,0,0.1)" />

    {/* Reefer Container */}
    <rect x="120" y="20" width="220" height="90" rx="6" fill="url(#reeferGrad)" stroke="#bfdbfe" strokeWidth="1" />

    {/* Cooling Unit Details */}
    <rect x="120" y="15" width="50" height="25" rx="4" fill="#475569" />
    <g opacity="0.6">
      <rect x="125" y="20" width="12" height="15" rx="1" fill="#1e293b" />
      <rect x="142" y="20" width="12" height="15" rx="1" fill="#1e293b" />
    </g>
    <text x="180" y="75" fontSize="30" fill="#3b82f6" opacity="0.3" pointerEvents="none">❄</text>

    {/* Cab */}
    <path d="M35 110 L35 55 Q35 35 55 35 L120 35 L120 110 Z" fill={fillColor} stroke="#cbd5e1" strokeWidth="1" />
    <rect x="45" y="45" width="60" height="35" rx="4" fill="#0f172a" />
    <rect x="50" y="48" width="50" height="20" rx="2" fill="#38bdf8" opacity="0.3" />

    {/* Wheels */}
    <g transform="translate(75, 110)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
    </g>
    <g transform="translate(280, 110)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
    </g>
  </svg>;


// Motorcycle/Scooter - High Fidelity
export const MotorcycleSVG = ({ className = "", fillColor = "#334155" }) =>
<svg viewBox="0 0 200 120" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="100" cy="100" rx="60" ry="6" fill="rgba(0,0,0,0.1)" />
    {/* Frame with Gradient */}
    <path d="M60 60 Q85 35 125 40 Q145 42 155 60" stroke="#1e293b" strokeWidth="8" fill="none" />
    <path d="M60 60 Q85 35 125 40 Q145 42 155 60" stroke={fillColor} strokeWidth="4" fill="none" opacity="0.8" />

    {/* Wheels - Multi-layer */}
    <g transform="translate(45, 85)">
      <circle cx="0" cy="0" r="22" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#64748b" opacity="0.4" />
      <circle cx="0" cy="0" r="5" fill="#374151" />
    </g>
    <g transform="translate(165, 85)">
      <circle cx="0" cy="0" r="22" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#64748b" opacity="0.4" />
      <circle cx="0" cy="0" r="5" fill="#374151" />
    </g>

    {/* Engine & Details */}
    <rect x="95" y="65" width="40" height="25" rx="4" fill="#475569" />
    <rect x="55" y="68" width="35" height="6" rx="3" fill="#94a3b8" />
    {/* Headlight */}
    <rect x="160" y="18" width="8" height="15" rx="2" fill="#fbbf24" />
    {/* Handlebar */}
    <line x1="155" y1="30" x2="175" y2="25" stroke="#1f2937" strokeWidth="3" />
    <line x1="155" y1="30" x2="145" y2="25" stroke="#1f2937" strokeWidth="3" />
  </svg>;


// Small Van / Minivan - High Fidelity
export const MinivanSVG = ({ className = "", fillColor = "#fdfdfd" }) =>
<svg viewBox="0 0 280 120" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="140" cy="105" rx="100" ry="8" fill="rgba(0,0,0,0.1)" />
    <path d="M30 95 L30 55 Q30 30 50 30 L190 30 Q230 30 240 55 L240 95 Z" fill={fillColor} stroke="#cbd5e1" strokeWidth="1" />

    {/* Dynamic Glass Surfaces */}
    <rect x="40" y="38" width="40" height="25" rx="4" fill="#0f172a" />
    <rect x="85" y="38" width="45" height="25" rx="4" fill="#0f172a" opacity="0.8" />
    <rect x="135" y="38" width="45" height="25" rx="4" fill="#0f172a" opacity="0.8" />
    <rect x="45" y="42" width="30" height="15" rx="2" fill="#38bdf8" opacity="0.3" />

    {/* Wheels */}
    <g transform="translate(70, 95)">
      <circle cx="0" cy="0" r="18" fill="#0f172a" />
      <circle cx="0" cy="0" r="12" fill="#334155" />
      <circle cx="0" cy="0" r="4" fill="#64748b" />
    </g>
    <g transform="translate(200, 95)">
      <circle cx="0" cy="0" r="18" fill="#0f172a" />
      <circle cx="0" cy="0" r="12" fill="#334155" />
      <circle cx="0" cy="0" r="4" fill="#64748b" />
    </g>
    {/* Door handles */}
    <rect x="85" y="58" width="10" height="3" rx="1" fill="#9ca3af" />
    <rect x="160" y="58" width="10" height="3" rx="1" fill="#9ca3af" />
    {/* Mirror */}
    <rect x="22" y="38" width="10" height="14" rx="2" fill="#374151" />
    {/* Headlight */}
    <rect x="225" y="50" width="4" height="12" rx="1" fill="#fbbf24" />
  </svg>;


// Sprinter / Large Van - High Fidelity
export const SprinterVanSVG = ({ className = "", fillColor = "#fdfdfd" }) =>
<svg viewBox="0 0 320 140" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="160" cy="120" rx="120" ry="10" fill="rgba(0,0,0,0.1)" />

    {/* High Roof Body */}
    <rect x="85" y="15" width="200" height="100" rx="10" fill={fillColor} stroke="#cbd5e1" strokeWidth="1" />
    <path d="M40 115 L40 55 Q40 35 60 35 L85 35 L85 115 Z" fill={fillColor} stroke="#cbd5e1" strokeWidth="1" />

    {/* Windows */}
    <rect x="50" y="42" width="50" height="35" rx="6" fill="#0f172a" />
    <rect x="55" y="45" width="40" height="20" rx="2" fill="#38bdf8" opacity="0.3" />
    <g opacity="0.1">
      <rect x="110" y="25" width="60" height="35" rx="4" fill="#1e293b" />
      <rect x="180" y="25" width="60" height="35" rx="4" fill="#1e293b" />
    </g>

    {/* Wheels */}
    <g transform="translate(75, 115)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
      <circle cx="0" cy="0" r="5" fill="#64748b" />
    </g>
    <g transform="translate(240, 115)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
      <circle cx="0" cy="0" r="5" fill="#64748b" />
    </g>

    {/* Bumper */}
    <rect x="35" y="112" width="60" height="8" rx="4" fill="#1e293b" />
    {/* Door handle */}
    <rect x="45" y="65" width="12" height="4" rx="2" fill="#9ca3af" />
    {/* Sliding door handle */}
    <rect x="180" y="55" width="15" height="5" rx="2" fill="#9ca3af" />
    {/* Mirror */}
    <rect x="22" y="40" width="10" height="18" rx="2" fill="#374151" />
    {/* Headlight */}
    <rect x="278" y="40" width="4" height="20" rx="1" fill="#fbbf24" />
  </svg>;


// Tow Truck - High Fidelity
export const TowTruckSVG = ({ className = "", fillColor = "#fdfdfd" }) =>
<svg viewBox="0 0 340 140" className={className} xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="180" cy="120" rx="120" ry="10" fill="rgba(0,0,0,0.1)" />

    {/* Flatbed/Tow Mechanism */}
    <rect x="110" y="85" width="200" height="15" rx="2" fill="#334155" />
    <path d="M280 85 L330 40 L340 45 L290 90 Z" fill="#475569" />

    {/* Cabin with Warning Lights */}
    <path d="M30 115 L30 55 Q30 35 55 35 L120 35 L120 115 Z" fill={fillColor} stroke="#cbd5e1" strokeWidth="1" />
    <rect x="40" y="25" width="60" height="10" rx="4" fill="#fbbf24" />
    <g opacity="0.8">
      <circle cx="50" cy="30" r="4" fill="#ef4444" />
      <circle cx="90" cy="30" r="4" fill="#3b82f6" />
    </g>

    {/* Windows */}
    <rect x="45" y="45" width="60" height="35" rx="4" fill="#0f172a" />
    <rect x="50" y="48" width="50" height="20" rx="2" fill="#38bdf8" opacity="0.3" />

    {/* Wheels */}
    <g transform="translate(75, 115)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
    </g>
    <g transform="translate(260, 115)">
      <circle cx="0" cy="0" r="20" fill="#0f172a" />
      <circle cx="0" cy="0" r="14" fill="#334155" />
    </g>
  </svg>;


// Map vehicle types to their SVG components (supports both lowercase and uppercase)
export const VEHICLE_ILLUSTRATIONS = {
  // Lowercase keys
  van: CargoVanSVG,
  cargo_van: CargoVanSVG,
  minivan: MinivanSVG,
  sprinter: SprinterVanSVG,
  box_truck: BoxTruckSVG,
  semi_truck: SemiTruckSVG,
  tractor_trailer: SemiTruckSVG,
  pickup: PickupTruckSVG,
  flatbed: FlatbedTruckSVG,
  refrigerated_truck: RefrigeratedTruckSVG,
  motorcycle: MotorcycleSVG,
  scooter: MotorcycleSVG,
  tow_truck: TowTruckSVG,
  // Uppercase keys (from API)
  VAN: CargoVanSVG,
  CARGO_VAN: CargoVanSVG,
  MINIVAN: MinivanSVG,
  SPRINTER: SprinterVanSVG,
  BOX_TRUCK: BoxTruckSVG,
  SEMI_TRUCK: SemiTruckSVG,
  TRACTOR_TRAILER: SemiTruckSVG,
  PICKUP: PickupTruckSVG,
  FLATBED: FlatbedTruckSVG,
  REFRIGERATED_TRUCK: RefrigeratedTruckSVG,
  MOTORCYCLE: MotorcycleSVG,
  SCOOTER: MotorcycleSVG,
  TOW_TRUCK: TowTruckSVG,
  // Default fallback
  default: BoxTruckSVG
};

// Get the appropriate illustration component for a vehicle type
export const getVehicleIllustration = (vehicleType) => {
  if (!vehicleType) return VEHICLE_ILLUSTRATIONS.default;
  // Handle both uppercase and lowercase
  const key = vehicleType.toString();
  return VEHICLE_ILLUSTRATIONS[key] || VEHICLE_ILLUSTRATIONS[key.toLowerCase()] || VEHICLE_ILLUSTRATIONS.default;
};

// Vehicle card with illustration and capacity indicator
export const VehicleIllustrationCard = ({
  vehicleType,
  vehicleCode,
  customImage,
  capacityPercent,
  fillColor = "#ffffff",
  trailerColor = "#ef4444",
  className = ""
}) => {const { t } = useTranslation("fleet");
  const IllustrationComponent = getVehicleIllustration(vehicleType);

  // If custom image is provided, use that instead
  if (customImage) {
    return (
      <div className={`relative ${className}`}>
        <img
          src={customImage}
          alt={vehicleCode || 'Vehicle'}
          className="w-full h-full object-contain" />
        
        {capacityPercent !== null && capacityPercent !== undefined &&
        <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-2xl font-bold text-white bg-red-500/80 px-3 py-1 rounded-lg">
              {capacityPercent}%
            </span>
          </div>
        }
      </div>);

  }

  // Use SVG illustration
  const typeStr = vehicleType?.toString()?.toLowerCase() || '';
  if (typeStr === 'semi_truck' || typeStr === 'tractor_trailer') {
    return (
      <IllustrationComponent
        className={className}
        trailerColor={trailerColor}
        capacityPercent={capacityPercent} />);


  }

  return (
    <div className={`relative ${className}`}>
      <IllustrationComponent className="w-full h-full" fillColor={fillColor} />
      {capacityPercent !== null && capacityPercent !== undefined &&
      <div className="absolute right-2 top-1/2 -translate-y-1/2 bg-red-500 text-white px-2 py-1 rounded text-sm font-bold">
          {capacityPercent}%
        </div>
      }
    </div>);

};

export default {
  CargoVanSVG,
  BoxTruckSVG,
  SemiTruckSVG,
  PickupTruckSVG,
  FlatbedTruckSVG,
  RefrigeratedTruckSVG,
  MotorcycleSVG,
  MinivanSVG,
  SprinterVanSVG,
  TowTruckSVG,
  VEHICLE_ILLUSTRATIONS,
  getVehicleIllustration,
  VehicleIllustrationCard
};